import {
  readSessionErrors,
  readVisitedRoutes,
} from "@/lib/analytics/session-diagnostics"

import { EMPTY_DIAGNOSTICS } from "./schema"
import type { BugReportDiagnostics } from "./types"

function safe(read: () => string): string {
  try {
    return read()
  } catch {
    return ""
  }
}

/**
 * Fotografa o browser no momento do envio.
 *
 * Só o que responde a "por que na máquina dele quebra e na minha não": rota,
 * navegação recente, erros da sessão, navegador, tamanho de tela, fuso e
 * idioma. Nada é lido de forma que possa lançar — um relato não pode morrer
 * por causa do próprio anexo.
 */
export function collectDiagnostics(): BugReportDiagnostics {
  if (typeof window === "undefined") {
    return { ...EMPTY_DIAGNOSTICS, routes: [], errors: [] }
  }

  return {
    url: safe(() => window.location.href),
    routes: readVisitedRoutes(),
    errors: readSessionErrors(),
    userAgent: safe(() => navigator.userAgent),
    viewport: safe(() => `${window.innerWidth}×${window.innerHeight}`),
    timezone: safe(() => Intl.DateTimeFormat().resolvedOptions().timeZone),
    language: safe(() => navigator.language),
  }
}
